var _defs, _circle, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwentyone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        opacity: .57;\n      }\n\n      .cls-1, .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3, .cls-4 {\n        fill: #1f2f60;\n      }\n\n      .cls-5 {\n        fill: #854343;\n      }\n\n      .cls-6 {\n        fill: #e9e8e8;\n      }\n\n      .cls-7 {\n        fill: #6e2b2a;\n      }\n\n      .cls-4 {\n        opacity: .44;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 548.03,
    cy: 569.73,
    r: 483.27
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M960.25,822.07c-159.47,260.03-530.57,307.04-749.39,93.87-55.54-219.45-111.09-438.9-166.64-658.36-5.62-22.25,9.59-45.27,33.97-51.44,212.76-53.86,425.53-107.7,638.3-161.55,24.4-6.17,48.72,6.84,54.36,29.1,63.12,249.46,126.27,498.92,189.4,748.38h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M663.17,232.37l-448.74,113.58c-7.92,2-15.97-2.79-17.97-10.71s2.79-15.97,10.71-17.97l448.74-113.58c7.92-2,15.97,2.79,17.97,10.71,2,7.92-2.79,15.97-10.71,17.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M690.75,341.37l-448.74,113.58c-7.92,2-15.97-2.79-17.97-10.71-2-7.92,2.79-15.97,10.71-17.97l448.74-113.58c7.92-2,15.97,2.79,17.97,10.71,2,7.92-2.79,15.97-10.71,17.97h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M719.67,455.62l-448.74,113.58c-7.92,2-15.97-2.79-17.97-10.71s2.79-15.97,10.71-17.97l448.74-113.58c7.92-2,15.97,2.79,17.97,10.71s-2.79,15.97-10.71,17.97h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M743.75,550.76l-448.74,113.58c-7.92,2-15.97-2.79-17.97-10.71-2-7.92,2.79-15.97,10.71-17.97l448.74-113.58c7.92-2,15.97,2.79,17.97,10.71,2,7.92-2.79,15.97-10.71,17.97Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M522.61,836.65c18.28,72.22-25.61,145.86-97.84,164.14-72.22,18.28-145.86-25.61-164.14-97.84-18.28-72.23,25.61-145.86,97.84-164.14,72.22-18.28,145.86,25.61,164.14,97.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M383.46,942.07c-3.67.93-7.69.46-11.2-1.63l-67.09-39.99c-7.02-4.18-9.32-13.26-5.13-20.28,4.18-7.02,13.27-9.31,20.28-5.13l54.39,32.42,69.55-116.69c4.18-7.02,13.27-9.31,20.28-5.13,7.02,4.18,9.32,13.26,5.13,20.28l-77.13,129.4c-2.09,3.51-5.41,5.83-9.08,6.76h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M782.71,704.69l-204.61,51.79c-7.92,2-15.97-2.79-17.97-10.71-2-7.92,2.79-15.97,10.71-17.97l204.61-51.79c7.92-2,15.97,2.79,17.97,10.71,2,7.92-2.79,15.97-10.71,17.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M805.62,795.21l-204.61,51.79c-7.92,2-15.97-2.79-17.97-10.71-2-7.92,2.79-15.97,10.71-17.97l204.61-51.79c7.92-2,15.97,2.79,17.97,10.71,2,7.92-2.79,15.97-10.71,17.97Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M862.86,114.77c.22-.82.44-1.64.68-2.45-.24.81-.47,1.63-.68,2.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M888.41,70.59c4.71-4.66,9.82-8.71,15.21-12.19-18.63,12.08-32.68,30.58-39.42,51.75,4.57-14.49,12.63-28.12,24.21-39.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M863.54,112.32c.2-.69.41-1.38.63-2.07-.22.69-.43,1.37-.63,2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M864.17,110.25s.02-.07.03-.11c-.01.04-.02.07-.03.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M903.89,58.23c-.09.06-.18.11-.27.17.09-.06.18-.11.27-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M907.77,55.86c-.73.42-1.45.85-2.16,1.29.71-.44,1.44-.87,2.16-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M905.61,57.15c-.58.35-1.15.72-1.72,1.08.57-.37,1.14-.73,1.72-1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1039.01,89.25c-22.81-37.3-69.14-54.24-110.48-42.22,34.01-9.97,72.67-1.11,98.31,26.19,4.69,5,8.75,10.38,12.17,16.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1024.7,207.68c-14.09,14.09-31.44,22.91-49.62,26.49-33.05,6.47-63.74,21.34-90.05,42.15l-65.76-65.76c2.89-3.67,5.63-7.42,8.27-11.26,3.6-5.2,6.99-10.56,10.14-16.05,8.54-14.87,15.33-30.71,20.07-47.26,0-.02,0-.04,0-.05.26-.87.5-1.75.73-2.62.72-2.61,1.38-5.25,1.99-7.89.4-1.77.78-3.53,1.14-5.31.15-.73.3-1.45.47-2.17.06-.3.13-.6.2-.9.18-.76.37-1.52.57-2.28,6.49-24.65,22.83-46.18,44.91-58.91.31-.18.62-.36.94-.52.5-.29,1-.57,1.51-.83.13-.08.27-.15.4-.21.57-.31,1.15-.61,1.73-.9.44-.23.88-.44,1.32-.65.58-.29,1.17-.57,1.77-.84,1.35-.62,2.72-1.21,4.09-1.76.36-.15.72-.29,1.09-.43.43-.17.87-.34,1.31-.5.4-.15.81-.3,1.22-.45.91-.32,1.81-.63,2.72-.92.45-.15.89-.28,1.33-.42.44-.14.88-.27,1.33-.4,41.34-12.02,87.67,4.92,110.48,42.22.37.6.73,1.2,1.08,1.81.52.91,1.03,1.82,1.53,2.75.26.49.52.98.77,1.47,0,.01,0,.02,0,.03,18.62,36.33,12.71,81.96-17.7,112.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M837.68,183.25c8.54-14.89,15.33-30.77,20.07-47.26-4.74,16.55-11.53,32.39-20.07,47.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M912.88,53.13c.26-.13.52-.26.79-.38-.44.21-.88.42-1.32.65.17-.09.35-.18.53-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1042.4,95.28v.03s0-.02,0-.03c-.25-.49-.51-.98-.77-1.47.27.49.53.98.78,1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M894.39,332.41l-.14.14-131.11-131.11.14-.14c3.57-3.57,7.77-6.15,12.22-7.73,3.58-1.3,7.38-1.94,11.14-1.94,8.45,0,16.9,3.21,23.36,9.67l84.39,84.39c9.33,9.33,11.93,22.86,7.74,34.52-1.59,4.43-4.17,8.63-7.74,12.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M902.13,320.2l-126.63-126.63c3.58-1.3,7.38-1.94,11.14-1.94,8.45,0,16.9,3.21,23.36,9.67l84.39,84.39c9.33,9.33,11.92,22.86,7.74,34.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M863.36,429l-10.81,10.81c-2.33,2.33-4.96,4.16-7.78,5.47-10.22,4.81-22.8,3-31.27-5.47l-157.61-157.61c-8.47-8.47-10.28-21.05-5.47-31.27,1.31-2.82,3.14-5.45,5.47-7.78l10.81-10.81,196.67,196.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M863.36,429l-10.81,10.81c-2.33,2.33-4.96,4.16-7.78,5.47l-194.35-194.35c1.31-2.82,3.14-5.45,5.47-7.78l10.81-10.81,196.67,196.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M903.04,452.08c-7.87,6.53-15.76,6.53-23.63,0l-235.81-235.81c-8.38-8.38-6.03-16.79.42-23.99,8.28-9.21,23.32-16.4,31.2-18.9,27.63-8.77,58.62-1.24,79.13,19.26l148.69,148.69c6.24,6.24,11.2,13.27,14.88,20.77,14.41,29.25,9.46,65.64-14.88,89.98h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M895.02,419.65c-7.87,6.53-15.76,6.53-23.63,0l-227.37-227.37c8.28-9.21,23.32-16.4,31.2-18.9,27.63-8.77,58.62-1.24,79.13,19.26l148.69,148.69c6.24,6.24,11.2,13.27,14.88,20.77.57,20.77-7.06,41.7-22.9,57.55Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwentyone);
export default __webpack_public_path__ + "static/media/twentyone.9c44f9e752cd64c8763d008bc08996f2.svg";
export { ForwardRef as ReactComponent };